<template>
  <b-nav v-if="!payAsYouGo && role !== 'subadmin'" class="main-nav">
    <b-nav-item class="logo" @click="$router.push('dashboard')">
      <img src="../assets/img/logo.png" />
    </b-nav-item>

    <!-- <b-nav-item class="logout Licence" @click="licenceShow()">Licence</b-nav-item>
    <b-nav-item class="logout Package" @click="packageShow(); callPackage()">Package</b-nav-item> -->

    <!-- Remove all item when reduce left space -->
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <b-nav-item></b-nav-item>
    <!-------------------------------------------->

    <b-nav-item class="logout dashboard" v-if="dashboardActive" active @click="dashboard()">
      Dashboard
    </b-nav-item>
    <b-nav-item class="logout dashboard" v-else @click="dashboard()">
      Dashboard
    </b-nav-item>

    <b-nav-item-dropdown class="logout Account" id="nav7_ddown" text="Account" extra-toggle-classes="nav-link-custom"
      extra-menu-classes="nav-item-color" right>
      <b-dropdown-item v-if="role === 'admin'" class="logout2">Add New User
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin'" class="logout2" @click="showUsers()">Users
      </b-dropdown-item>
      <!-- <b-dropdown-item v-if="role === 'admin'" class="logout2" @click="getLoginHistory()">Login History
      </b-dropdown-item> -->
      <b-dropdown-item v-if="role === 'admin'" class="logout2" @click="getUsageHistory()">Usage History
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'subadmin'" class="logout2" @click="profile()">Profile
      </b-dropdown-item>
      <!-- <b-dropdown-item class="logout2" @click="showPrivacy()">Privacy Policy</b-dropdown-item>
      <b-dropdown-item class="logout2" @click="showLegal()">Legal</b-dropdown-item> -->
      <b-dropdown-item class="logout2" @click="logout()">Logout</b-dropdown-item>
    </b-nav-item-dropdown>

    <b-modal v-model="licenceModalShow" hide-footer title="Licence Key">
      {{ licenceKey }}
    </b-modal>
    <b-modal size="md" v-model="packageModalShow" hide-footer title="Package"
      style="width: 200%; margin-left: auto; margin-right: auto;">
      {{ packageName }}
      <br><br>
      <div>
        <table>
          <tr>
            <!--  <td><img v-b-modal.creditModal
                     src="../assets/img/485-Gray.png"
                     style="width: 145px;"/>&nbsp;</td>
            <td><img v-b-modal.creditModal
                     src="../assets/img/1995-Gray.png"
                     style="width: 215px;"/>&nbsp;</td>
            <td><img v-b-modal.creditModal
                     src="../assets/img/3995-Gray.png"
                     style="width: 242px;"/>&nbsp;</td>-->
            <td><a href="/#/support">
                <img src="../assets/img/Custom-Gray.png" style="width: 215px;" /></a>&nbsp;</td>
            <td><img src="../assets/img/SI-Gray.png" style="width: 215px;" /></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <!--  <td>
              <img v-if="lightUpgrade"
                   @mouseover="lightUpgrade=false"
                   v-b-modal.creditModal
                   src="../assets/img/Upgrade-Button.png"
                   style="width: 145px; cursor: pointer;"/>
              <img v-else-if="!lightUpgrade"
                   @mouseleave="lightUpgrade=true"
                   v-b-modal.creditModal
                   src="../assets/img/Upgrade.png"
                   style="width: 145px; cursor: pointer;"/>&nbsp;</td>
            <td>  <img v-if="lightUpgrade1"
                       @mouseover="lightUpgrade1=false"
                       v-b-modal.creditModal
                       src="../assets/img/Upgrade-Button.png"
                       style="width: 182px; cursor: pointer;"/>
              <img v-else-if="!lightUpgrade1"
                   @mouseleave="lightUpgrade1=true"
                   v-b-modal.creditModal
                   src="../assets/img/Upgrade.png"
                   style="width: 182px; cursor: pointer;"/>&nbsp;</td>
            <td>  <img v-if="lightUpgrade2"
                       @mouseover="lightUpgrade2=false"
                       v-b-modal.creditModal
                       src="../assets/img/Upgrade-Button.png"
                       style="width: 242px; cursor: pointer;"/>
              <img v-else-if="!lightUpgrade2"
                   @mouseleave="lightUpgrade2=true"
                   v-b-modal.creditModal
                   src="../assets/img/Upgrade.png"
                   style="width: 242px; cursor: pointer;"/>&nbsp;</td>-->
            <td><a href="/#/support">
                <img v-if="lightUpgrade3" @mouseover="lightUpgrade3 = false" v-b-modal.creditModal
                  src="../assets/img/Contact-us-Button.png" style="width: 215px; cursor: pointer;" />
                <img v-else-if="!lightUpgrade3" @mouseleave="lightUpgrade3 = true" v-b-modal.creditModal
                  src="../assets/img/Contact-us.png" style="width: 215px; cursor: pointer;" /></a>&nbsp;</td>
            <td><a href="/#/support">
                <img v-if="lightUpgrade4" @mouseover="lightUpgrade4 = false" v-b-modal.creditModal
                  src="../assets/img/Contact-us-Button.png" style="width: 215px; cursor: pointer;" />
                <img v-else-if="!lightUpgrade4" @mouseleave="lightUpgrade4 = true" v-b-modal.creditModal
                  src="../assets/img/Contact-us.png" style="width: 215px; cursor: pointer;" /></a>&nbsp;</td>
          </tr>
        </table>
      </div>

    </b-modal>
    <b-modal id="creditModal" v-model="creditModal" hide-footer title="Add Credit">
      <b-form-select v-model="amount" class="mb-3" name="amount" v-validate="'required'" v-if="!purchase">
        <option value="null"> Select Package </option>
        <option v-for="(list, index) in options" v-bind:key="index"
          v-if="list.userId === '11111111-1111-1111-1111-111111111111' && country === 'United Kingdom'"
          :value="{ planId: list.planId, id: list.id }">
          {{ list.packageName }} - £{{ list.totalCost }}.00 + VAT 20%
        </option>
        <option v-for="(list, index) in options" v-bind:key="index"
          v-if="list.userId === '11111111-1111-1111-1111-111111111111' && country != 'United Kingdom'"
          :value="{ planId: list.planId, id: list.id }">
          {{ list.packageName }} - £{{ list.totalCost }}.00
        </option>
      </b-form-select>
      <span v-show="errors.has('amount')" class="help is-danger" style="text-align: left; margin-bottom: 10px;">
        {{ errors.first('amount') }}
      </span>
      <b-form-input v-if="purchase" v-model="inputValue" type="number" class="mb-3" name="amountValue"
        v-validate="'required|min_value:50|max_value:10000'" required placeholder="Enter Amount"></b-form-input>
      <span v-show="errors.has('amountValue')" class="help is-danger" style="text-align: left; margin-bottom: 10px;">
        {{ errors.first('amountValue') }}
      </span>
      <b-button class="buy-credits-button" v-if="purchase" variant="warning" @click="paymentPurchase">
        Add Credit
      </b-button>
      <b-button class="buy-credits-button" v-else variant="warning" @click="paymentCredits">
        Add Credit
      </b-button>
    </b-modal>
    <b-modal id="payAsGoModal" v-model="payAsGoModal" hide-footer title="Pay as you go">
      <b-form-input v-model="payAsGoValue" type="number" class="mb-3" name="payAsYouGoValue" disabled
        v-validate="'required'" required></b-form-input>
      <b-button class="buy-credits-button" variant="warning" @click="payAsGoPurchase">
        Add Credit
      </b-button>
    </b-modal>
    <b-modal v-model="confirmModal" title="Confirm Amount" ok-variant="secondary" ok-title="Yes" cancel-title="No"
      @ok="handleOk" @cancel="handleCancel">
      {{ confirmAmount }}
    </b-modal>
  </b-nav>
  <b-nav v-else class="main-nav">
    <b-nav-item class="logoPayAsGo" @click="$router.push('dashboard')">
      <img src="../assets/img/logo.png" />
    </b-nav-item>
    <b-nav-item class="logout dashboard" v-if="dashboardActive" active @click="dashboard()">
      Dashboard
    </b-nav-item>
    <b-nav-item class="logout dashboard" v-else @click="dashboard()">
      Dashboard
    </b-nav-item>
    <b-nav-item-dropdown class="logout" id="nav7_ddown" text="Account" extra-toggle-classes="nav-link-custom"
      extra-menu-classes="nav-item-color" right>
      <b-dropdown-item v-if="role === 'admin'" class="logout2" @click="showUsers()">Users
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin'" class="logout2" @click="getLoginHistory()">Login History
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin'" class="logout2" @click="getUsageHistory()">Usage History
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'subadmin'" class="logout2" @click="profile()">Profile
      </b-dropdown-item>
      <b-dropdown-item class="logout2" @click="showPrivacy()">Privacy Policy</b-dropdown-item>
      <b-dropdown-item class="logout2" @click="showLegal()">Legal</b-dropdown-item>
      <b-dropdown-item class="logout2" @click="logout()">Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import Session from '@/Session';
import API from '@/api';

export default {
  name: 'FacitHeader',
  data() {
    const token = Session.getAccessToken();
    const credits = token.user.credits;
    const purchased = token.user.purchased;
    const userRole = token.user.role;
    const payAsGo = token.user.payAsGo;
    return {
      credit: credits,
      amount: null,
      purchase: purchased,
      selectedOther: false,
      inputValue: null,
      creditModal: false,
      payAsGoModal: false,
      options: null,
      activeLink: null,
      country: null,
      packageNo: 1,
      confirmModal: false,
      confirmAmount: null,
      dashboardActive: true,
      licenceKey: null,
      licenceModalShow: false,
      packageName: null,
      packageModalShow: false,
      lightUpgrade: true,
      lightUpgrade1: true,
      lightUpgrade2: true,
      lightUpgrade3: true,
      lightUpgrade4: true,
      role: userRole,
      payAsGoValue: 150,
      payAsYouGo: payAsGo,
      subAdminProfile: false,
    };
  },
  created() {
    const token = Session.getAccessToken();
    const userId = token.user.id;
    const pageName = this.$route.name;
    const packageId = token.user.packageId;
    const purchased = token.user.purchased;
    const userCountry = token.user.country;
    this.country = userCountry;
    this.getPackageList();
    this.getAccount();
    const customMessage = {
      custom: {
        amountValue: {
          required: 'Amount field is required',
          min_value: 'Minimum order: £50.00',
          max_value: 'Maximum order: £10,000.00',
        },
        amount: {
          required: 'Please select package',
        },
      },
    };
    this.$validator.localize('en', customMessage);
    this.purchase = purchased;
    this.licenceKey = userId;
    if (pageName === 'dashboard') {
      this.dashboardActive = true;
    } else {
      this.dashboardActive = false;
    }

    this.getPackage(packageId);
  },
  methods: {
    async paymentCredits() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          let vatTax = 0;
          let devices = 1;
          const token = Session.getAccessToken();
          const userId = token.user.id;
          const country = token.user.country;
          const customer = token.user.customerId;
          const plan = this.amount.planId;
          const packageNo = this.amount.id;
          const address = token.user.address;
          this.creditModal = false;
          if (address) {
            if (country === 'United Kingdom') {
              vatTax = 20;
            }
            if (packageNo === 3) {
              devices = 5;
            } else if (packageNo === 4) {
              devices = 10;
            }
            await this.$checkout.open({
              name: 'Facit Data Systems',
              currency: 'GBP',
              token: async (newToken) => {
                try {
                  this.amount = null;
                  const tokenId = newToken.id;
                  const charged = await API.post(`Accounts/${userId}/charge`, {
                    token: tokenId,
                    customerId: customer,
                    vat: vatTax,
                    planId: plan,
                    packageId: packageNo,
                    totalDevices: devices,
                  });
                  Session.updateUser(charged);
                  this.credit = charged.credits;
                  this.$eventHub.$emit('credit-updated');
                  this.purchase = true;
                } catch (error) {
                  this.$eventHub.$emit('credit-updated');
                  this.$notify({
                    group: 'sitewide',
                    title: 'Error!',
                    type: 'error',
                    text: 'Error occured please try again!',
                  });
                }
              },
            });
          } else {
            this.$notify({
              group: 'sitewide',
              title: 'Error!',
              type: 'error',
              text: 'Kindly update profile!',
            });
            this.$router.push('/profile');
          }
        }
      } catch (error) {
        this.$eventHub.$emit('credit-updated');
        this.creditModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error occured please try again!',
        });
      }
    },
    async getPackageList() {
      try {
        const packageList = await API.get('PackageLists');
        this.options = packageList;
      } catch (error) {
        console.error(error);
      }
    },
    async paymentPurchase() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          this.confirmModal = true;
          this.confirmAmount = `Please confirm amount: £${this.inputValue}.00`;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async payAsGoPurchase() {
      try {
        //const validation = await this.$validator.validateAll();
        //if (validation) {
        this.confirmModal = true;
        this.confirmAmount = `Please confirm amount: £${this.payAsGoValue}.00`;
        //}
      } catch (error) {
        console.error(error);
      }
    },
    async getAccount() {
      try {
        const token = Session.getAccessToken();
        const userId = token.user.id;
        const AccountDetail = await API.get(`Accounts/${userId}/`);
        this.payAsYouGo = AccountDetail.payAsGo
        Session.updateUser(AccountDetail);
      } catch (error) {
        console.error(error);
      }
    },
    async handleOk() {
      try {
        let vatAmount = 0;
        const token = Session.getAccessToken();
        const userId = token.user.id;
        const country = token.user.country;
        const customer = token.user.customerId;
        let amount = 0
        if (this.payAsYouGo) {
          amount = parseInt(this.payAsGoValue, 10);
        } else {
          amount = parseInt(this.inputValue, 10);
        }
        const address = token.user.address;

        if (address) {
          if (country === 'United Kingdom') {
            vatAmount = amount * 0.2;
          }
          const totalAmount = (amount + vatAmount) * 100;
          await this.$checkout.open({
            name: 'Facit Data Systems',
            currency: 'GBP',
            amount: totalAmount,
            token: async (newToken) => {
              try {
                this.amount = null;
                const tokenId = newToken.id;
                const charged = await API.post(`Accounts/${userId}/purchase`, {
                  credits: totalAmount,
                  token: tokenId,
                  vat: vatAmount,
                  customerId: customer,
                  payAsGo: this.payAsYouGo,
                });
                Session.updateUser(charged);
                this.$eventHub.$emit('credit-updated');
                this.creditModal = false;
                this.credit = charged.credits;
              } catch (error) {
                this.$eventHub.$emit('credit-updated');
                this.creditModal = false;
                this.$notify({
                  group: 'sitewide',
                  title: 'Error!',
                  type: 'error',
                  text: 'Error occured please try again!',
                });
              }
            },
          });
        } else {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Kindly update profile!',
          });
          this.$router.push('/profile');
        }
      } catch (error) {
        this.$eventHub.$emit('credit-updated');
        this.creditModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error occured please try again!',
        });
      }
    },
    handleCancel() {
      this.creditModal = true;
    },
    logout() {
      Session.removeAccessToken();
      this.$router.push('../login');
    },
    dashboard() {
      if (this.role === 'subadmin') {
        this.$router.push('userDashboard');
      } else {
        this.$router.push('/');
      }

    },
    licenceShow() {
      this.licenceModalShow = true;
    },
    packageShow() {
      this.packageModalShow = true;
    },
    async callPackage() {
      let tok = Session.getAccessToken()
      const packageList = await API.get(`Accounts/${tok.userId}`);
      const purchased = packageList.purchased;
      const packId = packageList.packageId
      if (purchased) {
        const packageList = await API.get(`PackageLists/${packId}`);
        this.packageName = `Current Package: ${packageList.packageName} - £${packageList.totalCost}.00`;
      } else {
        this.packageName = 'Current Package: 7 Day Free Trial';
      }
    },
    async getPackage(packageId) {
      try {
        const token = Session.getAccessToken();
        const purchased = token.user.purchased;
        if (purchased) {
          const packageList = await API.get(`PackageLists/${packageId}`);
          this.packageName = `Current Package: ${packageList.packageName} - £${packageList.totalCost}.00`;
        } else {
          this.packageName = 'Current Package: 7 Day Free Trial';
        }
      } catch (error) {
        console.error(error);
      }
    },
    showLegal() {
      this.$router.push('../legal');
    },
    showPrivacy() {
      this.$router.push('../privacy');
    },
    showUsers() {
      this.$router.push('/admin/users');
    },
    async getLoginHistory() {
      this.$router.push(`/admin/loginHistory`);
    },
    async getUsageHistory() {
      this.$router.push(`/admin/usageHistory`);
    },
    profile() {
      this.$router.push('profile');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #656580 !important;
}

.dashboard a:hover {
  color: #ff8f00 !important;
}

.Licence a:hover {
  color: #ff8f00 !important;
}

.Package a:hover {
  color: #ff8f00 !important;
}

.Account :hover {
  color: #ff8f00 !important;
}

.dashboard a {
  color: white !important;
}

.Licence a {
  color: white !important;
}

.Package a {
  color: white !important;
}

.Account {
  color: white !important;
}

.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}

.logo {
  margin-top: 20px;
  width: 65%;
  margin-left: 30px;
}

.logoPayAsGo {
  margin-top: 20px;
  width: 80%;
  margin-left: 30px;
}

.logout {
  margin-top: 28px;
}

.logout2 {
  margin-top: 10px;
}

.active {
  color: #ff8f00 !important;
}

.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}

.help.is-danger {
  color: #ff3860;
}

.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
}

span {
  font-style: inherit;
  font-weight: inherit;
}

*,
:after,
:before {
  box-sizing: inherit;
}

.menu-item button {
  color: #656580 !important;
}

.nav-link-custom {
  background: white;
  border: #fe5623;
  color: #656580 !important;
}

.btn-link {
  color: red !important;
}


li>a>span {
  color: #656580 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue